import React from "react";

export default ( ) => {
  return (
    <div>
      ErrorPage
    </div>
  );
}